//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data() {
    return {
      menu: [
        { title: 'SPORT', url: '/', color: 'primary' },
        { title: 'LIVE BETTING', url: '/live', color: 'primary' },
        { title: 'Premium League', url: '/premium-league', color: 'primary' }
      ]
    }
  },
  computed: {
    tab() {
      let tab = 'sports';
      if(_.includes(this.$route.name, 'live')) {
        tab = 'live';
      }
      if(_.includes(this.$route.name, 'virtual')) {
        tab = 'virtual';
      }
      if(_.get(this.$store.state, 'tab')) {
        tab = _.get(this.$store.state, 'tab');
      }
      return tab
    },
    balance() {
      if (_.has(this.user, 'balance')) {
        return this.format_money(_.get(this.user, 'balance'), _.get(this.user, 'currency'))
      }
      return null
    },
    headerLinks(){
      return _.get(this.$store.state, 'globals.header_links', [])
    }
  },
  methods: {
    async goTo(url) {
      if (_.startsWith(url, 'http')) return url
      return this.localePath(url)
    },
    async openSignup() {
      this.$router.push(this.localePath({ path: '/auth/register' }))
    },
    async goHome() {
      this.loadGlobalIframe('hide_iframe', {}, true)
      if(this.$device.isMobile) {
        window.scroll({ top: 0, behavior: 'smooth' })
      } else {
        document.getElementById('main_body').scroll({ top: 0, behavior: 'smooth' })
      }
    },
    async closeIframe() {
      this.loadGlobalIframe('hide_iframe', {}, true)
    },
    async openLeftSidebar() {
      this.$store.commit('openLeftSidebar', true)
      this.$store.commit('betslip/toggleBetslip', false)
    },
    async openRightSidebar() {
      this.loadGlobalIframe('hide_iframe', {}, true)
      this.$store.commit('openRightSidebar', true)
      this.$store.commit('betslip/toggleBetslip', false)
    }
  }
}
